import type { ImageRequireSource } from 'react-native';
import { WhiteLabel } from 'app/types/white-labels';
import { isWhiteLabel } from 'app/utils/helpers';

export let images = {
  partagePlusBadge: require('/src/design/images/partage-plus-badge-v2.svg') as ImageRequireSource,
  partakePlusBadge: require('/src/design/images/partake-plus-badge.svg') as ImageRequireSource,
  footer_partage_club_logo: require('/src/design/images/footer-partage-club-logo.svg') as ImageRequireSource,
  footer_partake_logo: require('./footer-partake-logo.svg') as ImageRequireSource,
  google_play_fr: require('/src/design/images/google-play-fr.png') as ImageRequireSource,
  app_store_fr: require('/src/design/images/apple-store-fr.png') as ImageRequireSource,
  guest_google_play_fr: require('/src/design/images/google-play-figma-fr.png') as ImageRequireSource,
  guest_app_store_fr: require('/src/design/images/app-store-fr.png') as ImageRequireSource,
  qr_code_partage_club_app_store: require('/src/design/images/qrcodepartageclubappstore.png') as ImageRequireSource,
  qr_code_partage_club_google_play: require('/src/design/images/qrcodepartageclubgoogleplay.png') as ImageRequireSource,
  app_download_qr_code: require('/src/design/images/app-download-qr-code.png') as ImageRequireSource,
  qr_code_partake_app_store: require('/src/design/images/qrcodepartakeappstore.png') as ImageRequireSource,
  qr_code_partake_google_play: require('/src/design/images/qrcodepartakegoogleplay.png') as ImageRequireSource,
  guest_banner_thumbnail: require('/src/design/images/guest-banner-thumbnail.png') as ImageRequireSource,
  guest_banner_apple: require('/src/design/images/guest-banner-apple.svg') as ImageRequireSource,
  guest_banner_android: require('/src/design/images/guest-banner-android.svg') as ImageRequireSource,
  google_play_en: require('/src/design/images/google-play-en.png') as ImageRequireSource,
  app_store_en: require('/src/design/images/apple-store-en.png') as ImageRequireSource,
  404: 'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994308043_404_01GVNXQZ6S3SMHVHS77JP70RQT.png',
  handshake:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994313653_handshake_01GVNXR4PYKCZQX3AS3MSXX3S7.png',
  lightBulb:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994314359_light-bulb_01GVNXR5CS4BS4NKJMHMCKRK9F.png',
  megaphone:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994315723_megaphone_01GVNXR6QWPQ2TJWXNPBW7XZVT.png',
  messaging:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994316231_messaging_01GVNXR77ASMYBXKF34K1HAXJS.png',
  sight:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994316779_sight_01GVNXR7RDA4QXVPARQWJ9PFZF.png',
  target:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994318742_target_01GVNXR9MGBMREZ29PET5MH1R7.png',
  thinking:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994319236_thinking_01GVNXRA57Y0DHQCEW0QP3D9H3.png',
  update:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1678994324729_update_01GVNXRFFFXD0CR1E03D2FRTXG.png',
  trash:
    'https://userimg-assets.customeriomail.com/images/client-env-125923/1691503761232_dust_01H7AQP5ZX8CACMK2JMXVSR7YV.png',
  badge: {
    checked: {
      explorer: require('/src/design/images/impact/badge-explorer-checked.png') as ImageRequireSource,
      contributor: require('/src/design/images/impact/badge-contributor-checked.png') as ImageRequireSource,
      sharer: require('/src/design/images/impact/badge-sharer-checked.png') as ImageRequireSource,
      superSharer: require('/src/design/images/impact/badge-super_sharer-checked.png') as ImageRequireSource,
    },
    sharer: require('/src/design/images/impact/badge-sharer.png') as ImageRequireSource,
    superSharer: require('/src/design/images/impact/badge-super_sharer.png') as ImageRequireSource,
    lock: require('/src/design/images/impact/badge-lock.png') as ImageRequireSource,
    isSuper: require('/src/design/images/badge-is-super.png') as ImageRequireSource,
    isSuperNotYet: require('/src/design/images/badge-is-super-not-yet.png') as ImageRequireSource,
    // TODO: replace with dedicated ambassador badge images once available
    ambassador: require('/src/design/images/badge-is-super.png') as ImageRequireSource,
    ambassadorNotYet: require('/src/design/images/badge-is-super-not-yet.png') as ImageRequireSource,
  },
  savingMoney: require('/src/design/images/impact/saving-money.png') as ImageRequireSource,
  copy: require('/src/design/images/copy.png') as ImageRequireSource,
  dragon2024: require('/src/design/images/Dragon2024.jpg') as ImageRequireSource,
  refrainSplashLogo: require('/src/design/images/accesREFRAIN.png') as ImageRequireSource,
  introCommunity: require('/src/design/images/intro/community.png') as ImageRequireSource,
  introCleaner: require('/src/design/images/intro/cleaner.png') as ImageRequireSource,
  introInsured: require('/src/design/images/intro/insured.png') as ImageRequireSource,
  introPromo: require('/src/design/images/intro/promo.png') as ImageRequireSource,
  introBorrow: require('/src/design/images/intro/borrow.png') as ImageRequireSource,
  introPerson: require('/src/design/images/intro/personne.png') as ImageRequireSource,
  introPig: require('/src/design/images/intro/pig.png') as ImageRequireSource,
  introReferral: require('/src/design/images/intro/referral.png') as ImageRequireSource,
  introZeroOnePercent: require('/src/design/images/intro/zero-one-percent.png') as ImageRequireSource,
  introRefrain1: require('/src/design/images/intro/refrain1.png') as ImageRequireSource,
  introRefrain2: require('/src/design/images/intro/refrain2.png') as ImageRequireSource,
  introRefrain3: require('/src/design/images/intro/refrain3.png') as ImageRequireSource,
  introTessier1: require('/src/design/images/intro/tessier1.png') as ImageRequireSource,
  introTessier2: require('/src/design/images/intro/tessier2.png') as ImageRequireSource,
  introTessier3: require('/src/design/images/intro/tessier3.png') as ImageRequireSource,
  logoRefrain: require('/src/design/images/icon-refrain-rm-bg.png') as ImageRequireSource,
  refrainBeautyShot1: require('src/design/images/intro/RefrainBeautyShot.png') as ImageRequireSource,
  support: require('/src/design/images/intro/support.png') as ImageRequireSource,
  supportChatMascot: require('/src/design/images/support-chat/mascot-blink.png') as ImageRequireSource,
  supportChatMascotTyping: require('/src/design/images/support-chat/mascot-transparent-v2.png') as ImageRequireSource,
  notifSuperPartageur: require('/src/design/images/notif-super-partageur.png') as ImageRequireSource,
  inviteHeader: require('/src/design/images/invite-header.png') as ImageRequireSource,
  inviteOthersPrompt: require('/src/design/images/invite-others-prompt.png') as ImageRequireSource,
  martinBeauchamp: require('/src/design/images/martin-beauchamp.png') as ImageRequireSource,
  logoThreeLines: require('/src/design/images/logo3lines.png') as ImageRequireSource,
  logoThreeLinesPartake: require('/src/design/images/logo3lines-partake.png') as ImageRequireSource,
  navbar: require('/src/design/images/navbar.png') as ImageRequireSource,
  navbarEn: require('/src/design/images/navbar-en.png') as ImageRequireSource,
  snowboarder: require('/src/design/images/snowboarder.jpg') as ImageRequireSource,
  login: require('/src/design/images/login.png') as ImageRequireSource,
  skis: require('/src/design/images/skis.png') as ImageRequireSource,
  thumbnail1: require('/src/design/images/tente-x4.png') as ImageRequireSource,
  thumbnail2: require('/src/design/images/waffleMaker.png') as ImageRequireSource,
  thumbnail3: require('/src/design/images/dumbells.png') as ImageRequireSource,
  onboarding: {
    communityEn: require('/src/design/images/onboarding/community-en.png') as ImageRequireSource,
    communityFr: require('/src/design/images/onboarding/community-fr.png') as ImageRequireSource,
    communityBg: require('/src/design/images/onboarding/community-bg.png') as ImageRequireSource,
    accessMoreEn: require('/src/design/images/onboarding/access-more-en.png') as ImageRequireSource,
    accessMoreFr: require('/src/design/images/onboarding/access-more-fr.png') as ImageRequireSource,
    accessMoreBg: require('/src/design/images/onboarding/access-more-bg.jpg') as ImageRequireSource,
    offerMoreEn: require('/src/design/images/onboarding/offer-more-en.png') as ImageRequireSource,
    offerMoreFr: require('/src/design/images/onboarding/offer-more-fr.png') as ImageRequireSource,
    offerMoreBg: require('/src/design/images/onboarding/offer-more-bg.jpg') as ImageRequireSource,
    homme1: require('/src/design/images/onboarding/homme1.png') as ImageRequireSource,
    homme2: require('/src/design/images/onboarding/homme2.png') as ImageRequireSource,
    femme1: require('/src/design/images/onboarding/femme1.png') as ImageRequireSource,
    tente: require('/src/design/images/onboarding/tente.png') as ImageRequireSource,
    trotinette: require('/src/design/images/onboarding/trotinette.png') as ImageRequireSource,
    responsibility: require('/src/design/images/onboarding/responsibility.jpg') as ImageRequireSource,
    responsibilityFG: 0 as ImageRequireSource,
    respect: require('/src/design/images/onboarding/respect.jpg') as ImageRequireSource,
    respectFG: 0 as ImageRequireSource,
    transaction: require('/src/design/images/onboarding/transaction.jpg') as ImageRequireSource,
    transactionFG: 0 as ImageRequireSource,
    trust: require('/src/design/images/onboarding/trust.jpg') as ImageRequireSource,
    trustFG: 0 as ImageRequireSource,
    free: require('/src/design/images/onboarding/free.jpg') as ImageRequireSource,
    freeFG: 0 as ImageRequireSource,
    interests: require('/src/design/images/onboarding/interests.jpg') as ImageRequireSource,
  },
  web: {
    login: require('/src/design/images/login.png') as ImageRequireSource,
    login_foreground: require('/src/design/images/refrain/login-foreground.png') as ImageRequireSource,
    contact_information: require('/src/design/images/contact-information.png') as ImageRequireSource,
    credentials: require('/src/design/images/credentials.png') as ImageRequireSource,
    personal_information: require('/src/design/images/personal-information.png') as ImageRequireSource,
    guidelines: require('/src/design/images/guidelines.png') as ImageRequireSource,
    quick_choose: require('/src/design/images/refrain/quick-choose.png') as ImageRequireSource,
    thank_you: require('/src/design/images/refrain/thank-you.png') as ImageRequireSource,
    your_selection: require('/src/design/images/refrain/your-selection.png') as ImageRequireSource,
  },
  partners: 0 as ImageRequireSource,
  partnersDark: 0 as ImageRequireSource,
};

const imagesRefrain = {
  google_play_fr: require('/src/design/images/google-play-fr.png') as ImageRequireSource,
  app_store_fr: require('/src/design/images/apple-store-fr.png') as ImageRequireSource,
  google_play_en: require('/src/design/images/google-play-en.png') as ImageRequireSource,
  app_store_en: require('/src/design/images/apple-store-en.png') as ImageRequireSource,
  badge: {
    checked: {
      explorer: require('/src/design/images/impact/refrain/badge-explorer-checked.png') as ImageRequireSource,
      contributor: require('/src/design/images/impact/refrain/badge-contributor-checked.png') as ImageRequireSource,
      sharer: require('/src/design/images/impact/refrain/badge-sharer-checked.png') as ImageRequireSource,
      superSharer: require('/src/design/images/impact/refrain/badge-super_sharer-checked.png') as ImageRequireSource,
    },
    sharer: require('/src/design/images/impact/refrain/badge-sharer.png') as ImageRequireSource,
    superSharer: require('/src/design/images/impact/refrain/badge-super_sharer.png') as ImageRequireSource,
    lock: require('/src/design/images/impact/refrain/badge-lock.png') as ImageRequireSource,
    isSuper: require('/src/design/images/badge-is-super.png') as ImageRequireSource,
    isSuperNotYet: require('/src/design/images/badge-is-super-not-yet.png') as ImageRequireSource,
  },
  notifSuperPartageur: require('/src/design/images/notif-super-partageur.png') as ImageRequireSource,
  introRefrain1: require('/src/design/images/intro/refrain1.png') as ImageRequireSource,
  logoRefrain: require('/src/design/images/icon-refrain-rm-bg.png') as ImageRequireSource,
  refrainBeautyShot1: require('src/design/images/intro/RefrainBeautyShot.png') as ImageRequireSource,
  onboarding: {
    communityEn: require('/src/design/images/refrain/onboarding/hero-img-01-eng.png') as ImageRequireSource,
    communityFr: require('/src/design/images/refrain/onboarding/hero-img-01-fr.png') as ImageRequireSource,
    communityBg: require('/src/design/images/refrain/onboarding/bg-img-hero-01.png') as ImageRequireSource,
    accessMoreEn: require('/src/design/images/refrain/onboarding/hero-img-02-eng.png') as ImageRequireSource,
    accessMoreFr: require('/src/design/images/refrain/onboarding/hero-img-02-fr.png') as ImageRequireSource,
    accessMoreBg: require('/src/design/images/refrain/onboarding/bg-img-hero-02.png') as ImageRequireSource,
    offerMoreEn: require('/src/design/images/refrain/onboarding/hero-img-03-eng.png') as ImageRequireSource,
    offerMoreFr: require('/src/design/images/refrain/onboarding/hero-img-03-fr.png') as ImageRequireSource,
    offerMoreBg: require('/src/design/images/refrain/onboarding/bg-img-hero-03.png') as ImageRequireSource,
  },
  web: {
    login: require('/src/design/images/refrain/login.png') as ImageRequireSource,
    login_foreground: require('/src/design/images/refrain/login-foreground.png') as ImageRequireSource,
    contact_information: require('/src/design/images/refrain/contact-information.png') as ImageRequireSource,
    credentials: require('/src/design/images/refrain/credentials.png') as ImageRequireSource,
    personal_information: require('/src/design/images/refrain/personal-information.png') as ImageRequireSource,
    guidelines: require('/src/design/images/refrain/guidelines.png') as ImageRequireSource,
    quick_choose: require('/src/design/images/refrain/quick-choose.png') as ImageRequireSource,
    thank_you: require('/src/design/images/refrain/thank-you.png') as ImageRequireSource,
    your_selection: require('/src/design/images/refrain/your-selection.png') as ImageRequireSource,
  },
};

if (isWhiteLabel(WhiteLabel.Refrain)) {
  images = Object.assign(images, imagesRefrain);
}

const imagesSerresTessier = {
  google_play_fr: require('/src/design/images/google-play-fr.png') as ImageRequireSource,
  app_store_fr: require('/src/design/images/apple-store-fr.png') as ImageRequireSource,
  google_play_en: require('/src/design/images/google-play-en.png') as ImageRequireSource,
  app_store_en: require('/src/design/images/apple-store-en.png') as ImageRequireSource,
  badge: {
    checked: {
      explorer: require('/src/design/images/impact/badge-explorer-checked.png') as ImageRequireSource,
      contributor: require('/src/design/images/impact/badge-contributor-checked.png') as ImageRequireSource,
      sharer: require('/src/design/images/impact/badge-sharer-checked.png') as ImageRequireSource,
      superSharer: require('/src/design/images/impact/badge-super_sharer-checked.png') as ImageRequireSource,
    },
    sharer: require('/src/design/images/impact/badge-sharer.png') as ImageRequireSource,
    superSharer: require('/src/design/images/impact/badge-super_sharer.png') as ImageRequireSource,
    lock: require('/src/design/images/impact/badge-lock.png') as ImageRequireSource,
    isSuper: require('/src/design/images/serrestessier/badge-is-super.png') as ImageRequireSource,
    isSuperNotYet: require('/src/design/images/badge-is-super-not-yet.png') as ImageRequireSource,
  },
  notifSuperPartageur: require('/src/design/images/serrestessier/notif-super-partageur.png') as ImageRequireSource,
};

if (isWhiteLabel(WhiteLabel.SerresTessier)) {
  images = Object.assign(images, imagesSerresTessier);
}

const imagesMutuo = {
  google_play_fr: require('/src/design/images/google-play-fr.png') as ImageRequireSource,
  app_store_fr: require('/src/design/images/apple-store-fr.png') as ImageRequireSource,
  google_play_en: require('/src/design/images/google-play-en.png') as ImageRequireSource,
  app_store_en: require('/src/design/images/apple-store-en.png') as ImageRequireSource,
  badge: {
    checked: {
      explorer: require('/src/design/images/impact/badge-explorer-checked.png') as ImageRequireSource,
      contributor: require('/src/design/images/impact/badge-contributor-checked.png') as ImageRequireSource,
      sharer: require('/src/design/images/impact/badge-sharer-checked.png') as ImageRequireSource,
      superSharer: require('/src/design/images/impact/badge-super_sharer-checked.png') as ImageRequireSource,
    },
    sharer: require('/src/design/images/impact/badge-sharer.png') as ImageRequireSource,
    superSharer: require('/src/design/images/impact/badge-super_sharer.png') as ImageRequireSource,
    lock: require('/src/design/images/impact/badge-lock.png') as ImageRequireSource,
    isSuper: require('/src/design/images/mutuo/badge-is-super.png') as ImageRequireSource,
    isSuperNotYet: require('/src/design/images/badge-is-super-not-yet.png') as ImageRequireSource,
  },
  notifSuperPartageur: require('/src/design/images/mutuo/notif-super-partageur.png') as ImageRequireSource,
  onboarding: {
    communityEn: require('/src/design/images/mutuo/onboarding/hero-thumbnail-01.png') as ImageRequireSource,
    communityFr: require('/src/design/images/mutuo/onboarding/hero-thumbnail-01.png') as ImageRequireSource,
    communityBg: require('/src/design/images/mutuo/onboarding/bg-img-hero-01.jpg') as ImageRequireSource,
    accessMoreEn: require('/src/design/images/mutuo/onboarding/hero-thumbnail-02.png') as ImageRequireSource,
    accessMoreFr: require('/src/design/images/mutuo/onboarding/hero-thumbnail-02.png') as ImageRequireSource,
    accessMoreBg: require('/src/design/images/mutuo/onboarding/bg-img-hero-02.jpg') as ImageRequireSource,
    offerMoreEn: require('/src/design/images/mutuo/onboarding/hero-thumbnail-03.png') as ImageRequireSource,
    offerMoreFr: require('/src/design/images/mutuo/onboarding/hero-thumbnail-03.png') as ImageRequireSource,
    offerMoreBg: require('/src/design/images/mutuo/onboarding/bg-img-hero-03.jpg') as ImageRequireSource,
    homme1: require('/src/design/images/onboarding/homme1.png') as ImageRequireSource,
    homme2: require('/src/design/images/onboarding/homme2.png') as ImageRequireSource,
    femme1: require('/src/design/images/onboarding/femme1.png') as ImageRequireSource,
    tente: require('/src/design/images/onboarding/tente.png') as ImageRequireSource,
    trotinette: require('/src/design/images/onboarding/trotinette.png') as ImageRequireSource,
    responsibility: 0 as ImageRequireSource,
    respect: require('/src/design/images/mutuo/onboarding/bg-image-slide-01.jpg') as ImageRequireSource,
    respectFG: require('/src/design/images/mutuo/onboarding/thumbnail-slide-01.png') as ImageRequireSource,
    transaction: require('/src/design/images/mutuo/onboarding/bg-image-slide-02.jpg') as ImageRequireSource,
    transactionFG: require('/src/design/images/mutuo/onboarding/thumbnail-slide-02.png') as ImageRequireSource,
    trust: require('/src/design/images/mutuo/onboarding/bg-image-slide-03.jpg') as ImageRequireSource,
    trustFG: require('/src/design/images/mutuo/onboarding/thumbnail-slide-03.png') as ImageRequireSource,
    free: 0 as ImageRequireSource,
    interests: require('/src/design/images/mutuo/onboarding/modal-cover.jpg') as ImageRequireSource,
  },
  web: {
    login: require('/src/design/images/refrain/login.png') as ImageRequireSource,
    login_foreground: require('/src/design/images/refrain/login-foreground.png') as ImageRequireSource,
    contact_information: require('/src/design/images/mutuo/bg-img-flow.jpg') as ImageRequireSource,
    credentials: require('/src/design/images/mutuo/bg-img-flow.jpg') as ImageRequireSource,
    personal_information: require('/src/design/images/mutuo/bg-img-flow.jpg') as ImageRequireSource,
    guidelines: require('/src/design/images/mutuo/bg-img-flow.jpg') as ImageRequireSource,
    quick_choose: require('/src/design/images/refrain/quick-choose.png') as ImageRequireSource,
    thank_you: require('/src/design/images/refrain/thank-you.png') as ImageRequireSource,
    your_selection: require('/src/design/images/refrain/your-selection.png') as ImageRequireSource,
  },
  partners: require('/src/design/images/mutuo/partners.png') as ImageRequireSource,
  partnersDark: require('/src/design/images/mutuo/partners-dark.png') as ImageRequireSource,
  thumbnail1: require('/src/design/images/mutuo/thumbnail-1.png') as ImageRequireSource,
  thumbnail2: require('/src/design/images/mutuo/thumbnail-2.png') as ImageRequireSource,
  thumbnail3: require('/src/design/images/mutuo/thumbnail-3.png') as ImageRequireSource,
};

if (isWhiteLabel(WhiteLabel.Mutuo)) {
  images = Object.assign(images, imagesMutuo);
}
const imageHautegaspesie = {
  google_play_fr: require('/src/design/images/google-play-fr.png') as ImageRequireSource,
  app_store_fr: require('/src/design/images/apple-store-fr.png') as ImageRequireSource,
  google_play_en: require('/src/design/images/google-play-en.png') as ImageRequireSource,
  app_store_en: require('/src/design/images/apple-store-en.png') as ImageRequireSource,
  thumbnail1: require('/src/design/images/hautegaspesie/thumbnail1.png') as ImageRequireSource,
  thumbnail2: require('/src/design/images/hautegaspesie/thumbnail2.png') as ImageRequireSource,
  thumbnail3: require('/src/design/images/hautegaspesie/thumbnail3.png') as ImageRequireSource,
  onboarding: {
    communityEn: require('/src/design/images/hautegaspesie/onboarding/hero-thumbnail-01.png') as ImageRequireSource,
    communityFr: require('/src/design/images/hautegaspesie/onboarding/hero-thumbnail-01.png') as ImageRequireSource,
    communityBg: require('/src/design/images/hautegaspesie/onboarding/hero-bg-img-01.png') as ImageRequireSource,
    accessMoreEn: require('/src/design/images/hautegaspesie/onboarding/hero-thumbnail-02.png') as ImageRequireSource,
    accessMoreFr: require('/src/design/images/hautegaspesie/onboarding/hero-thumbnail-02.png') as ImageRequireSource,
    accessMoreBg: require('/src/design/images/hautegaspesie/onboarding/hero-bg-img-02.png') as ImageRequireSource,
    offerMoreEn: require('/src/design/images/hautegaspesie/onboarding/hero-thumbnail-03.png') as ImageRequireSource,
    offerMoreFr: require('/src/design/images/hautegaspesie/onboarding/hero-thumbnail-03.png') as ImageRequireSource,
    offerMoreBg: require('/src/design/images/hautegaspesie/onboarding/hero-bg-img-03.png') as ImageRequireSource,
    homme1: require('/src/design/images/onboarding/homme1.png') as ImageRequireSource,
    homme2: require('/src/design/images/onboarding/homme2.png') as ImageRequireSource,
    femme1: require('/src/design/images/onboarding/femme1.png') as ImageRequireSource,
    tente: require('/src/design/images/onboarding/tente.png') as ImageRequireSource,
    trotinette: require('/src/design/images/onboarding/trotinette.png') as ImageRequireSource,
    responsibility: 0 as ImageRequireSource,
    respect: require('/src/design/images/mutuo/onboarding/bg-image-slide-01.jpg') as ImageRequireSource,
    respectFG: require('/src/design/images/mutuo/onboarding/thumbnail-slide-01.png') as ImageRequireSource,
    transaction: require('/src/design/images/mutuo/onboarding/bg-image-slide-02.jpg') as ImageRequireSource,
    transactionFG: require('/src/design/images/mutuo/onboarding/thumbnail-slide-02.png') as ImageRequireSource,
    trust: require('/src/design/images/mutuo/onboarding/bg-image-slide-03.jpg') as ImageRequireSource,
    trustFG: require('/src/design/images/mutuo/onboarding/thumbnail-slide-03.png') as ImageRequireSource,
    free: 0 as ImageRequireSource,
    interests: require('/src/design/images/mutuo/onboarding/modal-cover.jpg') as ImageRequireSource,
  },
  web: {
    login: require('/src/design/images/hautegaspesie/flow-bg-img.png') as ImageRequireSource,
    contact_information: require('/src/design/images/hautegaspesie/flow-bg-img.png') as ImageRequireSource,
    credentials: require('/src/design/images/hautegaspesie/flow-bg-img.png') as ImageRequireSource,
    personal_information: require('/src/design/images/hautegaspesie/flow-bg-img.png') as ImageRequireSource,
    guidelines: require('/src/design/images/hautegaspesie/flow-bg-img.png') as ImageRequireSource,
    // quick_choose: require('/src/design/images/refrain/quick-choose.png') as ImageRequireSource,
    // thank_you: require('/src/design/images/refrain/thank-you.png') as ImageRequireSource,
    // your_selection: require('/src/design/images/refrain/your-selection.png') as ImageRequireSource,
  },
  badge: {
    checked: {
      explorer: require('/src/design/images/impact/badge-explorer-checked.png') as ImageRequireSource,
      contributor: require('/src/design/images/impact/badge-contributor-checked.png') as ImageRequireSource,
      sharer: require('/src/design/images/impact/badge-sharer-checked.png') as ImageRequireSource,
      superSharer: require('/src/design/images/impact/badge-super_sharer-checked.png') as ImageRequireSource,
    },
    sharer: require('/src/design/images/impact/badge-sharer.png') as ImageRequireSource,
    superSharer: require('/src/design/images/impact/badge-super_sharer.png') as ImageRequireSource,
    lock: require('/src/design/images/impact/badge-lock.png') as ImageRequireSource,
    isSuper: require('/src/design/images/hautegaspesie/badge-is-super.png') as ImageRequireSource,
    isSuperNotYet: require('/src/design/images/badge-is-super-not-yet.png') as ImageRequireSource,
  },
  notifSuperPartageur: require('/src/design/images/hautegaspesie/notif-super-partageur.png') as ImageRequireSource,
};

if (isWhiteLabel(WhiteLabel.HauteGaspesie)) {
  images = {
    ...images,
    ...imageHautegaspesie,
    onboarding: { ...images.onboarding, ...imageHautegaspesie.onboarding },
    web: { ...images.web, ...imageHautegaspesie.web },
    badge: { ...images.badge, ...imageHautegaspesie.badge },
  };
}
